var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "home-feed" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "home-feed__tabs" },
      [
        _vm._l(_vm.tabs, function (tab) {
          return _c(
            "button",
            {
              key: tab.key,
              staticClass: "home-feed__tab",
              class: { "home-feed__tab--active": _vm.activeTab === tab.key },
              on: {
                click: function ($event) {
                  return _vm.setTab(tab.key)
                },
              },
            },
            [_vm._v("\n      " + _vm._s(tab.label) + "\n    ")]
          )
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "home-feed__filter-btn",
            on: {
              click: function ($event) {
                return _vm.$emit("open-filters")
              },
            },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  width: "14",
                  height: "14",
                  viewBox: "0 0 16 16",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M1 3h14M4 8h8M6 13h4",
                    stroke: "currentColor",
                    "stroke-width": "1.5",
                    "stroke-linecap": "round",
                  },
                }),
              ]
            ),
            _vm._v("\n      Filter\n    "),
          ]
        ),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "home-feed__list" },
      [
        _vm._l(_vm.visibleArticles, function (article) {
          return _c(
            "article",
            {
              key: article.nid || article.url || article.title,
              staticClass: "feed-card",
            },
            [
              _c("div", { staticClass: "feed-card__meta" }, [
                article.contentType
                  ? _c("span", { staticClass: "feed-card__type" }, [
                      _vm._v(_vm._s(article.contentType)),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                article.author
                  ? _c("span", { staticClass: "feed-card__dot" }, [_vm._v("·")])
                  : _vm._e(),
                _vm._v(" "),
                article.author
                  ? _c("span", { staticClass: "feed-card__author" }, [
                      _vm._v(_vm._s(article.author)),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                article.publishedDate
                  ? _c("span", { staticClass: "feed-card__dot" }, [_vm._v("·")])
                  : _vm._e(),
                _vm._v(" "),
                article.publishedDate
                  ? _c("span", { staticClass: "feed-card__date" }, [
                      _vm._v(_vm._s(article.publishedDate)),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "nuxt-link",
                {
                  staticClass: "feed-card__title-link",
                  attrs: { to: _vm.articleLink(article) },
                },
                [
                  _c("h3", { staticClass: "feed-card__title" }, [
                    _vm._v(_vm._s(_vm.decodeText(article.title))),
                  ]),
                ]
              ),
              _vm._v(" "),
              article.summary
                ? _c("p", { staticClass: "feed-card__summary" }, [
                    _vm._v(_vm._s(_vm.decodeText(article.summary))),
                  ])
                : _vm._e(),
              _vm._v(" "),
              article.tags && article.tags.length
                ? _c(
                    "div",
                    { staticClass: "feed-card__tags" },
                    [
                      _vm._l(article.tags.slice(0, 3), function (tag) {
                        return _c(
                          "nuxt-link",
                          {
                            key: tag.tid || tag.title,
                            staticClass: "feed-card__tag",
                            attrs: { to: tag.url || "#" },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(tag.title || tag.name || tag) +
                                "\n        "
                            ),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      article.tags.length > 3
                        ? _c(
                            "span",
                            {
                              staticClass:
                                "feed-card__tag feed-card__tag--more",
                            },
                            [
                              _vm._v(
                                "\n          +" +
                                  _vm._s(article.tags.length - 3) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          )
        }),
        _vm._v(" "),
        !_vm.filteredArticles.length && !_vm.loading
          ? _c("div", { staticClass: "home-feed__empty" }, [
              _vm._v("\n      No articles found for this filter.\n    "),
            ])
          : _vm._e(),
      ],
      2
    ),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "home-feed__loader" }, [
          _c("div", { staticClass: "home-feed__spinner" }),
          _vm._v(" "),
          _c("span", [_vm._v("Loading more articles...")]),
        ])
      : _vm.canShowMore
      ? _c("div", { staticClass: "home-feed__load-more" }, [
          _c(
            "button",
            {
              staticClass: "home-feed__load-more-btn",
              on: { click: _vm.handleLoadMore },
            },
            [_vm._v("\n      Load More\n    ")]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "home-feed__header" }, [
      _c("h2", { staticClass: "home-feed__title" }, [_vm._v("Your feed")]),
      _vm._v(" "),
      _c("p", { staticClass: "home-feed__subtitle" }, [
        _vm._v("Insights and analysis from our experts"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }